import React, { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";

import BreadCrumb from "Components/Common/BreadCrumb";
import DocumentItem from "pages/Admin/UserDocuments/DocumentItem";
import DocumentModal from "./DocumentModal";
import { getOptionValue } from "common/enums";

import { useGetMenuContentQuery } from "apis/HomePage";

const HomePageDocument = ({ t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: { data: menuItemByContentTypeData = [] } = {} } =
    useGetMenuContentQuery({
      contentType: getOptionValue("homeContentType", "Document"),
    });

  return (
    <>
      {isOpen && (
        <DocumentModal
          handleClose={() => {
            setIsOpen(false);
          }}
          isOpen={isOpen}
          menuData={menuItemByContentTypeData}
        />
      )}
      <BreadCrumb title={t("Home Page Documents")} />
      <div className="text-end mb-2">
        <Button
          sx={{ maxHeight: "40px" }}
          variant="contained"
          color="primary"
          onClick={() => setIsOpen(true)}
        >
          {t("Update")}
        </Button>
      </div>
      {!!menuItemByContentTypeData.length && (
        <div className="d-flex gap-3 flex-wrap">
          {menuItemByContentTypeData.map(({ content, name }, index) => (
            <DocumentItem
              document={{ path: content, documentName: `${name}.pdf` }}
              key={index}
            />
          ))}
        </div>
      )}
      {!menuItemByContentTypeData.length && (
        <Typography
          color="GrayText"
          textAlign="center"
          variant="body1"
          className="ms-1 mt-1"
        >
          {t("There is no Documents!")}
        </Typography>
      )}
    </>
  );
};

HomePageDocument.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(HomePageDocument);
